import React, { createContext, useContext, useEffect, useState } from 'react';
import { adminApi, TOKEN_KEY } from '../lib/adminApi';

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null); // null=checking, false=guest, object=auth

  useEffect(() => {
    const t = localStorage.getItem(TOKEN_KEY);
    if (!t) { setAdmin(false); return; }
    adminApi.get('/auth/me')
      .then((r) => setAdmin(r.data))
      .catch(() => { localStorage.removeItem(TOKEN_KEY); setAdmin(false); });
  }, []);

  const login = async (email, password) => {
    const { data } = await adminApi.post('/auth/login', { email, password });
    localStorage.setItem(TOKEN_KEY, data.access_token);
    setAdmin(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ admin, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
